import type { FaireProductEntity } from "../../entity_types/product";

export const p_tzgyvxtycp: FaireProductEntity = {
  token: "p_tzgyvxtycp",
  type: "product",
  name: "Gluten Free Snack|Karma Pops Variety Pack All 7 Flavors",
  brandToken: "b_2ppngtaknh",
  brandName: "Karma Wellness Kitchen",
  imageUrl:
    "https://cdn.faire.com/fastly/99cbcd23dc0614a9cadca773a82dd5cbcc09e46427487769c9f29a2180e56151.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/66fcad27d999cd0e5271b4f4a379fd1d98d3cf3817466016ee8c9d87ea7be02a.png",
    "https://cdn.faire.com/fastly/8f8428dc30ec472f4755f05e6159c4ce81b9ddd48520e0ff7f3b6421112537f9.png",
    "https://cdn.faire.com/fastly/ff8b3cf871b6a745de00398c8a495af3a7bfc9950e282124f5230df3aa51765c.png",
    "https://cdn.faire.com/fastly/3dd8249754cd4d1e5c1d036d6e73e09f80ca54128971ffc70eaa3e80b071c96a.png",
    "https://cdn.faire.com/fastly/5809587baae5a6b4d3b75009917a2f06dfc8972ec1314058e311e032c44d8a79.png",
    "https://cdn.faire.com/fastly/a39f1a818a981cfab988f991a1ee33610339f331e9358af875568a38ec738cef.png",
    "https://cdn.faire.com/fastly/35391a722635d481734f74ce665f360b928bc7db61251c864a23314b2df29221.png",
    "https://cdn.faire.com/fastly/bf49c909c0426dffe4149103fd53565980b1c3c9c926da11420fac737dda4ca9.png",
  ],
  priceDollars: 16,
  description:
    "Popped Water Lily Seeds are protein rich, super food snack. \n\n3 gm protein, 3 gm fiber, Gluten Free alternative to Popcorn or Chips. \n\nOur variety pack contains all of our delicious flavors - Classic Sea Salt, Spicy Masala, Apple Cider Vinegar, White Cheddar, Turmeric, Chocolate and Vegan Cheese\n\nWe have multiple variations for you to choose from. \n\n1 oz bags. \n\n",
  tags: [],
  msrpDollars: 32,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:59:12.511Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
